/* eslint-disable react/jsx-wrap-multilines */
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { CargoExpressDeliveryFormView } from './cargo-pickup-form-view';
import { FORM_NAME } from '../../constants';
import { getIsReqInfoLoadingSelector, getReqInfoSelector } from '../../selectors';
import { validate } from '../../utils';

const CargoExpressDeliveryFormWrapper = ({ reqInfo, isLoading }) => {
	return <CargoExpressDeliveryFormView reqInfo={reqInfo} isLoading={isLoading} />;
};

const withForm = reduxForm({
	form: FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(CargoExpressDeliveryFormWrapper);

const mapStateToProps = createStructuredSelector({
	reqInfo: getReqInfoSelector(),
	isLoading: getIsReqInfoLoadingSelector(),
});

const CargoExpressDeliveryForm = connect(mapStateToProps)(withForm);

CargoExpressDeliveryFormWrapper.propTypes = {
	reqInfo: PropTypes.object,
	isLoading: PropTypes.bool,
};

export { CargoExpressDeliveryForm };
